import content from "../../content.json";
import manifestoSrcs from "url:../../maps/manifesto/high/*";
import * as classes from "./manifesto.module.scss";
import { ActionType, AppContext } from "../../contexts/AppContext";
import { useCallback, useContext, useEffect, useState } from "react";
import Button from "../Button/Button";
import classNames from "classnames";

const SLIDE_DURATION = 4500;

const Manifesto = () => {
  const { dispatch } = useContext(AppContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIsActive, setCurrentIsActive] = useState(false);

  const progressSlide = useCallback(
    (direction = 1) => {
      let newIndex = currentIndex + direction;
      if (newIndex < 0) {
        newIndex = Object.keys(manifestoSrcs).length - 1;
      }
      if (newIndex >= Object.keys(manifestoSrcs).length) {
        newIndex = 0;
      }
      setCurrentIndex(newIndex);
      setCurrentIsActive(false);
    },
    [currentIndex]
  );

  useEffect(() => {
    dispatch({ type: ActionType.SetManifestoSlide, value: currentIndex });
    setTimeout(() => {
      setCurrentIsActive(true);
    }, 0);

    const timeout = setTimeout(progressSlide, SLIDE_DURATION);

    return () => {
      clearTimeout(timeout);
    };
  }, [currentIndex]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        progressSlide(-1);
      } else if (e.key == "ArrowRight") {
        progressSlide(1);
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => window.removeEventListener("keydown", onKeyDown);
  }, [currentIndex]);

  return (
    <div className={classes.root}>
      <button
        className={classes.previous}
        aria-label="Previous slide"
        onClick={() => {
          progressSlide(-1);
        }}
      ></button>
      <button
        className={classes.next}
        aria-label="Next slide"
        onClick={() => {
          progressSlide(1);
        }}
      ></button>
      <div className={classes.indicators}>
        {Object.keys(manifestoSrcs).map((key, index) => {
          return (
            <button
              style={
                {
                  "--transition-duration":
                    index === currentIndex ? `${SLIDE_DURATION}ms` : "0ms",
                } as any
              }
              key={key}
              className={classNames(classes.indicator, {
                [classes["indicator--current"]]: index === currentIndex,
                [classes["indicator--current-active"]]:
                  index === currentIndex && currentIsActive,
                [classes["indicator--done"]]: index < currentIndex,
                [classes["indicator--upcoming"]]: index > currentIndex,
              })}
              onClick={() => {
                setCurrentIsActive(false);
                setCurrentIndex(index);
              }}
            >
              <div className={classes["indicator-inner"]}></div>
            </button>
          );
        })}
      </div>
      <h2 style={{ opacity: 0, position: "absolute", pointerEvents: "none" }}>
        Manifesto
      </h2>
      <section
        style={{ opacity: 0, position: "absolute", pointerEvents: "none" }}
      >
        {content.manifesto.copy.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </section>

      <Button
        className={classes.close}
        type="button"
        label="Close"
        onClick={() => {
          dispatch({ type: ActionType.SetModal, value: null });
        }}
      />
    </div>
  );
};

export default Manifesto;
